import { ref, onMounted } from 'vue'
import * as signalR from '@microsoft/signalr'
import { useUserStore } from '@/stores/user'

interface MessageCallback {
  (message: MessageInfo): void
}

interface SendMessageACKCallback {
  (messageId: string): void
}

interface MessageInfo {
  messageId: string
  systemMessage: {
    systemMessageType: string
    textForSender: string
    textForReceiver: string
    invitationId: string
    date: string
    time: string
    invitationType: string
    excuse: string
  } | null
  senderId: string
  receiverId: string
  message: string
  timestamp: string
  mediaAttachment?: {
    ContentType: string
    FileUrl: string
    PreviewUrl: string
    PreviewDimensions: string
  }
}

export function useSignalR() {
  const { getTokens } = useUserStore()
  const connection = ref<signalR.HubConnection | null>(null)

  const startConnection = async (accessToken: string) => {
    try {
      connection.value = new signalR.HubConnectionBuilder()
        .withUrl(`${import.meta.env.VITE_APP_CHAT_BASE_URL}chatHub?access_token=${accessToken}`)
        .withAutomaticReconnect()
        .build()

      await connection.value.start()
      console.log('SignalR bağlantısı başarılı bir şekilde başlatıldı.')
    } catch (error) {
      console.error('SignalR bağlantısı başlatılamadı:', error)
    }
  }

  const SendMessage = async (messageId: string, receiverId: string, message: string, MediaAttachment: any) => {
    try {
      await connection.value?.invoke('SendMessage', messageId, receiverId, message, MediaAttachment)
      console.log('Mesaj başarıyla gönderildi:', { messageId, receiverId, message, MediaAttachment })
    } catch (error) {
      console.error('Mesaj gönderilirken hata oluştu:', error)
    }
  }

  const SendMessageACK = (callback: SendMessageACKCallback) => {
    if (!connection.value) {
      console.warn('SignalR bağlantısı hazır değil, SendMessageACK dinleyicisi eklenemedi.')
      return
    }

    connection.value.on('SendMessageACK', (messageId) => {
      console.log('SendMessageACK:', messageId)
      callback(messageId)
    })
  }

  const listenToMessages = (callback: MessageCallback) => {
    if (!connection.value) {
      console.warn('SignalR bağlantısı hazır değil, ReceiveMessage dinleyicisi eklenemedi.')
      return
    }

    connection.value.on('ReceiveMessage', (messageId, senderId, receiverId, message, timestamp,  mediaAttachment, systemMessage) => {
      console.log('Alınan mesaj:', { senderId, receiverId, message, timestamp, systemMessage, mediaAttachment })
      const messageInfo: MessageInfo = {
        messageId: messageId,
        senderId,
        receiverId,
        message,
        timestamp,
        mediaAttachment,
        systemMessage: systemMessage ?? null,
      }

      console.log('Alınan mesaj:', messageInfo)
      callback(messageInfo)
    })
  }

  onMounted(async () => {
    try {
      const accessToken = getTokens.value.accessToken
      if (!accessToken) {
        console.warn('Access token mevcut değil.')
        return
      }
      await startConnection(accessToken)
    } catch (error) {
      console.error('SignalR bağlantısı sırasında hata oluştu:', error)
    }
  })

  return {
    SendMessage,
    SendMessageACK,
    listenToMessages
  }
}
